<!-- SAP单号信息 -->
<script>
import TablePage from '@/found/components/table_page';

export default {
  name: 'table-component',
  extends: TablePage,
  props: {
    value: Array,
  },
  async created() {
    await this.getConfigList('audit_SAP_order_list');
  },
  watch: {
    value(val) {
      this.tableData = val;
    },
  },
};
</script>
